import { Button, CloseButton } from "react-bootstrap";
import React from "react";

export const textInput = ({
  input,
  type,
  placeholder,
  label,
  defaultValue,
  id,
  autoFocus,
  meta: { touched, error },
  className,
  style,
  noErrorDisplay,
  autoComplete,
  listData = [],
  deleteListItemAction,
  selectListItem,
  ...rest
}) => {
  let listId = 'datalist' + input.name;
  let add_validation_id = ''

  if(className === "empty-content_container"){
   add_validation_id = touched && error ? "input_validaion_border": null
  }else {
    add_validation_id = touched && error ? "input_validaion": null
  } 

  const deleteItem = (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    
    deleteListItemAction?.(id);
  };

  const handleSelectAnItem = (id) => {
    selectListItem?.(id);
  };

  return (
    <div className={`position-relative data-list-container ${className}`} style={style} id={add_validation_id}>
      { label ?  <label className="mb-1"> {label}</label> : null}
      <input
        {...input}
        type={type}
        placeholder={placeholder}
        id={id}
        className={rest.input_class_name ? rest.input_class_name : "form-control"}
        autoFocus={autoFocus}
        {...autoComplete && { autoComplete }}
      />

      {listData.length > 0 && (
        <ul id={listId} className="data-list show box-shadow">
          {listData.map((item, i) => (
            <li 
              key={item.id} 
              className="d-flex align-items-center justify-content-between mb-1 cursor-pointer py-1 px-2 rounded-4" 
              onMouseDown={() => handleSelectAnItem(item.id)}
            >
              <span className="">{item.value}</span> 
              <CloseButton type='button'onMouseDown={(e) => deleteItem(e, item.id)}></CloseButton>
            </li>
          ))}
        </ul>
      )}

      {noErrorDisplay === undefined && touched && error && <span className="form-error">{error}</span>}
    </div>
  );
};

export default textInput;
